export const GET_CONTRACTS = 'GET_CONTRACTS';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_CONTRACTS = 'ERROR_CONTRACTS';